import { useDispatch } from 'react-redux';

// Runs one dispatch function straight away and another function after 650ms
export const useSubmitAndCloseDropdown = () => {
  const dispatch = useDispatch();

  // This isSlice function isnt great, won't be necessary once slices are fully implemented
  const submitAndCloseDropdown = (value, func, selectFunc, isSliceFunction) => {
    if (isSliceFunction) {
      dispatch(func(value));
    } else {
      func(dispatch, value);
    }
    setTimeout(() => {
      selectFunc(false);
    }, 650);
  };

  return { submitAndCloseDropdown };
};
